var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button is-small is-light is-success teacher-tag",on:{"click":_vm.remove}},[_vm._v(" "+_vm._s(_vm.getTeacherName(_vm.teacher))+" "),_c('span',[_vm._v(" ⨯")])])}
var staticRenderFns = []

export { render, staticRenderFns }